/**
 * Loomlite has no single "Location" table. The competition system exposes
 * a virtual "Location" content type that expands to these real tables.
 *
 * Mirrored on the edge function side at:
 *   Lantern.Firebase/supabase/functions/competition-snapshot/index.ts
 * Keep the two lists in sync.
 */

export const LOCATION_VIRTUAL_TYPE = 'Location' as const;

export const LOCATION_SUB_TABLES = [
	'Cities',
	'Towns',
	'Villages',
	'Continents',
	'Countrys',
] as const;

export type LocationSubTable = (typeof LOCATION_SUB_TABLES)[number];

export interface LocationSubTableMeta {
	label: string;
	description: string;
}

export const LOCATION_SUB_TABLE_META: Record<LocationSubTable, LocationSubTableMeta> = {
	Cities: { label: 'City', description: 'Urban centres, capitals' },
	Towns: { label: 'Town', description: 'Smaller settlements, hamlets' },
	Villages: { label: 'Village', description: 'Rural villages, outposts' },
	Continents: { label: 'Continent', description: 'Continent-scale regions' },
	Countrys: { label: 'Country', description: 'Nations, kingdoms, realms' },
};

export function isLocationSubTable(value: string): value is LocationSubTable {
	return (LOCATION_SUB_TABLES as readonly string[]).includes(value);
}

/**
 * If `allowed` contains the virtual "Location" type, replace it with the
 * five real sub-tables. De-duplicates while preserving first-seen order.
 */
export function expandLocationInAllowedTypes(allowed: readonly string[]): string[] {
	const out: string[] = [];
	const seen = new Set<string>();
	const push = (t: string) => {
		if (!seen.has(t)) {
			seen.add(t);
			out.push(t);
		}
	};
	for (const t of allowed) {
		if (t === LOCATION_VIRTUAL_TYPE) {
			for (const sub of LOCATION_SUB_TABLES) push(sub);
		} else {
			push(t);
		}
	}
	return out;
}
